import { render } from "./PropsChild.vue?vue&type=template&id=c47e6cfc"
import script from "./PropsChild.vue?vue&type=script&lang=js"
export * from "./PropsChild.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__